import React from "react";
import {
  Grid,
  Box,
  Typography,
  Container,
  Divider,
} from "@mui/material";
import InfoField from "./InfoField";
import ControlField from "./ControlField";

// Iconos
import BusinessIcon from "@mui/icons-material/Business";
import StorefrontIcon from "@mui/icons-material/Storefront";

function DatosFacturacion({ cliente, selectorSucursal, letra }) {
  return (
    <Container maxWidth="xl" disableGutters sx={{ mb: 1 }}>
      <Box sx={{ py: { xs: 1, md: 2 }, px: 4 }}>
        <Grid container spacing={2.5}>
          <Grid item xs={12} sm={6} md={3.8}>
            <InfoField
              icon={<BusinessIcon sx={{ fontSize: 16 }} />}
              label="Empresa"
              value={cliente?.empresa_cliente}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3.8}>
            <InfoField
              icon={<StorefrontIcon sx={{ fontSize: 16 }} />}
              label="Suc. Cliente"
              value={cliente?.sucursal_cliente}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3.8}>
            <ControlField
              icon={<StorefrontIcon sx={{ fontSize: 16 }} />}
              label="Suc. Factura"
            >
              <Box sx={{ maxWidth: 220 }}>{selectorSucursal}</Box>
            </ControlField>
          </Grid>

          <Grid
            item
            xs={12}
            md={0.6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            {letra?.letra && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 48,
                  height: 48,
                  borderRadius: "8px",
                  backgroundColor: "primary.main",
                  color: "primary.contrastText",
                  boxShadow: 2,
                  flexShrink: 0,
                }}
              >
                <Typography
                  variant="h4"
                  component="span"
                  sx={{ fontWeight: "bold", lineHeight: 1 }}
                >
                  {letra.letra}
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
      <Divider />
    </Container>
  );
}

export default DatosFacturacion;

/*
<FormControl
  variant="outlined"
  size="small"
  fullWidth
  // disabled={
  //   !dataCliente ||
  //   !permisos["facturaotraempresa"] ||
  //   comprobanteAsociado
  // }
>
  <InputLabel id="label-empresa-emisora">
    Empresa Que Factura
  </InputLabel>
  <Select
    // sx={{ backgroundColor: bgColor }}
    // value={formData.empEmisora}
    onChange={(e) => {
      // setFormData({
      //   ...formData,
      //   empEmisora: e.target.value,
      //   sucEmisora: userSucData?.id_alias ? formData.sucEmisora : "",
      // });
      // getSucEmpresa(e.target.value);
      // if (e.target.value !== dataCliente.id_empresa)
      //   alert(
      //     "Atención: Esta factura no estará en la empresa del cliente."
      //   );
    }}
    label="Empresa Que Factura"
  >
      {empresas.map((empresa) => (
      <MenuItem key={empresa.id} value={empresa.idempresa} disabled={getOptionDisabledEmpresas(empresa)}>
        {empresa.empresa}
      </MenuItem>
    ))} 
  </Select>
</FormControl>
*/